import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-boolean-cell',
  imports: [TranslatePipe],
  templateUrl: './boolean-cell.component.html',
  styleUrl: './boolean-cell.component.scss',
})
export class BooleanCellComponent {
  public readonly value = input.required<boolean | null>();
}
